module.exports = __webpack_public_path__ + "media/images/pages/instagram-35d9174a9f3f0705297cdce1cc25a917.png";